@if (lightboxItem.Type === ATTACHMENT_TYPES.IMG) {
  <image-preloader [cropped]="isCropped" [imageSrc]="trustedResourceUrl"></image-preloader>
} @else {
  <div [ngClass]="{ 'iframe-video': lightboxItem.Type !== ATTACHMENT_TYPES.OTHER }" class="lightbox-video">
    @if (!showVideo) {
      <div #videoPlug class="video-plug">
        <img [src]="lightboxItem.ThumbnailUrl" (click)="show()" />
      </div>
    }
    @if (showVideo && (lightboxItem.Type === ATTACHMENT_TYPES.YT || ATTACHMENT_TYPES.VIMEO)) {
      <iframe
        [src]="trustedResourceUrl"
        #iframeEl
        allowfullscreen
        frameborder="0"
        height="{{ videoSize.height }}"
        mozallowfullscreen
        webkitallowfullscreen
        width="{{ videoSize.width }}"
      ></iframe>
    }
    @if (showVideo && lightboxItem.Type === ATTACHMENT_TYPES.OTHER) {
      <video
        [src]="trustedResourceUrl"
        #videoEl
        autoplay
        controls
        controlsList="nodownload"
        height="{{ videoSize.height }}"
        width="{{ videoSize.width }}"
      ></video>
    }
  </div>
}
